// extracted by mini-css-extract-plugin
module.exports = {"footer":"C_Q g_p"};